import { useEffect, useState } from "react";
import globalStyles from "../../../../../../../assets/styles/base/globalPage.module.scss";
// import { useNavigate } from "react-router-dom";
import styles from "./styles.module.scss";
import LoaderHelper from "../../../../../../../components/secondaryComponents/LoaderHelper/LoaderHelper";
import {
  Outlet,
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { pathConstants } from "../../../../../../../routes/pathContants";
import { useCreateFoodMenu } from "../../useCreateFoodMenu";
import { ArrowRight } from "../../../../../../../assets/svgIcons";
import primaryComponents from "../../../../../../../components/primaryComponents";

const CustomizationNavigation = () => {
  const {
    menuProperties,
    isFetchingMenuCategories,
    sortMenuCategories,
    setSortMenuCategories,
  } = useCreateFoodMenu();

  const navigate = useNavigate();
  const { menuId } = useParams();
  const [searchParams] = useSearchParams();
  const [selectedMenuTab, setSelectedMenuTab] = useState("Checkout");
  const { pathname } = useLocation();

  const customizationTab = [
    {
      name: "Checkout",
      route: pathname.includes("create")
        ? pathConstants.INVENTORY_MENU_CREATE_CUSTOMIZATION_CHECKOUT({
            menuId: menuId ? menuId : searchParams.get("menu_id"),
          }) + `?store_id=${searchParams.get("store_id")}`
        : pathConstants.INVENTORY_MENU_DETAILS_CUSTOMIZATION_CHECKOUT({
            menuId: menuId ? menuId : searchParams.get("menu_id"),
          }) + `?store_id=${menuProperties?.store?.id}`,
    },
    {
      name: "Payment",
      route: pathname.includes("create")
        ? pathConstants.INVENTORY_MENU_CREATE_CUSTOMIZATION_PAYMENT({
            menuId: menuId ? menuId : searchParams.get("menu_id"),
          }) + `?store_id=${searchParams.get("store_id")}`
        : pathConstants.INVENTORY_MENU_DETAILS_CUSTOMIZATION_PAYMENT({
            menuId: menuId ? menuId : searchParams.get("menu_id"),
          }) + `?store_id=${menuProperties?.store?.id}`,
    },
    {
      name: "Templates",
      route: pathname.includes("create")
        ? pathConstants.INVENTORY_MENU_CREATE_CUSTOMIZATION_TEMPLATES({
            menuId: menuId ? menuId : searchParams.get("menu_id"),
          }) + `?store_id=${searchParams.get("store_id")}`
        : pathConstants.INVENTORY_MENU_DETAILS_CUSTOMIZATION_TEMPLATES({
            menuId: menuId ? menuId : searchParams.get("menu_id"),
          }) + `?store_id=${menuProperties?.store?.id}`,
    },
    // {
    //   name: "Branding",
    //   route: pathname.includes("create")
    //     ? pathConstants.INVENTORY_MENU_CREATE_CUSTOMIZATION_BRANDING({
    //         menuId: menuId ? menuId : searchParams.get("menu_id"),
    //       }) + `?store_id=${searchParams.get("store_id")}`
    //     : pathConstants.INVENTORY_MENU_DETAILS_CUSTOMIZATION_BRANDING({
    //         menuId: menuId ? menuId : searchParams.get("menu_id"),
    //       }) + `?store_id=${menuProperties?.store?.id}`,
    // },
    // {
    //   name: "Sort Categories",
    //   route: pathname.includes("create")
    //     ? pathConstants.INVENTORY_MENU_CREATE_CUSTOMIZATION_SORT_CATEGORIES({
    //         menuId: menuId ? menuId : searchParams.get("menu_id"),
    //       }) + `?store_id=${searchParams.get("store_id")}`
    //     : pathConstants.INVENTORY_MENU_DETAILS_CUSTOMIZATION_SORT_CATEGORIES({
    //         menuId: menuId ? menuId : searchParams.get("menu_id"),
    //       }) + `?store_id=${menuProperties?.store?.id}`,
    // },
  ];

  useEffect(() => {
    if (pathname.includes("checkout")) {
      setSelectedMenuTab("Checkout");
    } else if (pathname.includes("payment")) {
      setSelectedMenuTab("Payment");
    } else if (pathname.includes("templates")) {
      setSelectedMenuTab("Templates");
    } else if (pathname.includes("branding")) {
      setSelectedMenuTab("Branding");
    } else {
      setSelectedMenuTab("Sort Categories");
    }
  }, [pathname]);

  return (
    <div className={styles.container}>
      <LoaderHelper classNames={"mt-4"} isLoading={!menuProperties}>
        <div
          style={{
            justifyContent: "center",
          }}
          className={globalStyles.rowNavigations}
        >
          {customizationTab?.map((item, index) => (
            // eslint-disable-next-line
            <a
              key={index}
              className={`${globalStyles.rowNavigations__item} ${
                item.name === selectedMenuTab ? globalStyles.active : ""
              }`}
              onClick={() => {
                setSelectedMenuTab(item.name);
                navigate(item.route);
              }}
            >
              {item?.name}
            </a>
          ))}
        </div>
        <div className={styles.tabContent}>
          <Outlet
            context={{
              menuProperties,
              isFetchingMenuCategories,
              sortMenuCategories,
              setSortMenuCategories,
            }}
          />
        </div>

        <div className="mt-5 ml-auto">
          <primaryComponents.Button
            classNames={"btn btn--primary ml-auto"}
            style={{ width: "150px" }}
            onClick={() =>
              navigate(
                pathConstants.INVENTORY_MENU_CREATE_SHIPPING({
                  menuId: menuProperties?.id,
                }),
              )
            }
          >
            <ArrowRight style={{ fontSize: "25px" }} className="mr-1" />
            Next
          </primaryComponents.Button>
        </div>
      </LoaderHelper>
    </div>
  );
};

export default CustomizationNavigation;
